/* eslint-disable camelcase */
import { ApiService } from '~/shared/api'
import type { TogglePromotionParams } from '~/interfaces/AccountVacancies'

export default class AccountVacanciesPromotionService extends ApiService {
  protected route: string = 'vacancies/promotion'

  togglePromotion({ baseUrl, token, vacancyId, promotionValue }: TogglePromotionParams) {
    return this.requestService.request({
      url: `/api/v1/yavagro/vacancies/${vacancyId}/promotion`,
      baseURL: baseUrl,
      method: 'POST',
      data: { promotion_value: promotionValue },
      headers: { 'Authorization-SF-Token': token }
    })
  }
}
